import button from './PrintButton.vue'
const PrintButton = {
  install: function (Vue) {
    Vue.component('PrintButton', button)
  }
}
export default PrintButton
